module.exports = __webpack_public_path__ + "static/media/DEEPA JI_page-0001.8473c2d7.jpg";